module.exports = __webpack_public_path__ + "static/media/bankActive.252b2bdb.svg";